<template>
  <div class="r-info">
    <span v-if="[undefined, null].includes(text)" class="text-body-3 text-grey3">N/A</span>

    <template v-else-if="link">
      <a
        v-if="$attrs.absoluteUrl"
        :href="$attrs.to"
        :target="$attrs.newTab ? '_blank' : null"
        rel="noopener noreferrer"
        class="r-info__link text-body-4 text-link-blue"
      >
        {{ text }}
      </a>

      <router-link v-else class="r-info__link text-subtitle-1 text-link-blue" v-bind="$attrs">
        {{ text }}
      </router-link>
    </template>

    <span v-else align-items="center" class="text-body-4 text-secondary-1">{{ text }}</span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    link: Boolean,
    text: [String, Number]
  }
}
</script>

<style lang="scss" scoped>
.r-info {
  &__link {
    text-decoration: none;
  }
}
</style>
